module.exports = __webpack_public_path__ + "img/0Q3A5798_L_BlackMatted_MockedUp.08623f17.jpg";